<template>
  <div id="Navbar" class="fixed-top">
    <b-navbar toggleable="lg">
      <b-navbar-brand to="/">
        <img src="../assets/logo.png" class="logo" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse" type="button" toogle="collapse">
        <span class="custom-toggler-icon">
          <i class="fas fa-bars"></i>
        </span>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item :to="{ name: 'home', hash: '#values' }"
            >Values</b-nav-item
          >
          <b-nav-item :to="{ name: 'home', hash: '#portfolio' }"
            >Portfolio</b-nav-item
          >
          <b-nav-item to="tachi15">Tachi.ai15</b-nav-item>
          <b-nav-item :to="{ name: 'home', hash: '#contact' }"
            >Contact</b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
#Navbar .navbar {
  padding: 0 1rem;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.1rem;
  background-color: rgba(0, 0, 0, 0.8);
}

#Navbar .custom-toggler-icon .fas {
  color: white;
  font-size: 1.6rem;
}

#Navbar .navbar .navbar-nav .nav-link {
  color: white;
  padding-top: 0.8rem;
}

#Navbar .navbar-nav .nav-link.active,
#Navbar .navbar-nav .nav-link:hover {
  background-color: #e74c3c;
  height: 100%;
}

#Navbar .navbar-toggler-icon {
  color: white;
}

#Navbar .navbar-brand img {
  height: 3rem;
}
</style>